// @ts-expect-error png import
import LandingPageBuilderHero from 'bender-url!./images/LandingPageBuilderHero.png';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import BrandVoiceIcon from './images/icons/BrandVoiceIcon';
import ContentAgentIcon from './images/icons/ContentAgentIcon';
import ContentRemixIcon from './images/icons/ContentRemixIcon';
import FormsIcon from './images/icons/FormsIcon';
import SolutionCardLayoutUI from './SolutionCardLayoutUI';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LandingPageBuilderCard = () => {
  return /*#__PURE__*/_jsx(SolutionCardLayoutUI, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.solutionCards.landingPageBuilder.title"
    }),
    subheading: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.hsoc.solutionCards.landingPageBuilder.subheading"
        })
      }), ' ', /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Link, {
          underline: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.hsoc.solutionCards.learnMore"
          })
        })
      })]
    }),
    features: [{
      icon: /*#__PURE__*/_jsx(ContentAgentIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.contentAgent.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.contentAgent.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(ContentRemixIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.contentRemix.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.contentRemix.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(FormsIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.forms.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.forms.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(BrandVoiceIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.brandVoice.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.brandVoice.description"
      })
    }],
    image: /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      blockSize: "100%",
      justifyContent: "center",
      alignItems: "center",
      paddingBlockStart: "800",
      children: /*#__PURE__*/_jsx(Image, {
        src: LandingPageBuilderHero,
        zIndex: 1
      })
    }),
    footer: /*#__PURE__*/_jsx(Link, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.seePricing"
      })
    })
  });
};
export default LandingPageBuilderCard;